import { useState, useEffect, useContext, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import config from "../../../../config/config";
import { useParams } from "react-router-dom";
import { toastError } from "../../../../common/Toast";
import { ERROR_MESSAGE, ERROR_EXISTS } from "../../../../common/Constant";
import Loader from "../../../../components/Loader/Loader";
import { AppContext } from "../../../../context/AppContext";

const ItemAttributeTableRows = ({
  rowsData,
  deleteTableRows,
  globalAttribute,
  attributeName,
  attributeValue,
}) => {
  const token = localStorage.getItem("Token");
  const [pull, setPull] = useState(false);
  const [loading, setLoading] = useState(false);
  const loginUserId = localStorage.getItem("ID");
  const paramObject = useParams();
  const selectRef = useRef();

  // for App Context-
  const { autoGenerationFunction } = useContext(AppContext);

  // setting props into state-
  const [data, setData] = useState({
    newRowsData: rowsData,
    newGlobalAttribute: globalAttribute,
    newAttributeName: attributeName,
    newAttributeValue: attributeValue,
  });

  // Use Effect-
  useEffect(() => {
    setData({
      ...data,
      newRowsData: rowsData,
      newGlobalAttribute: globalAttribute,
      newAttributeName: attributeName,
      newAttributeValue: attributeValue,
    });
  }, [rowsData, pull]);

  // Insert Function-
  const insertAttributeFunction = (selected, Attributeid) => {
    const keyValues = selected.map((obj) => obj.value);
    const commaSeparatedValues = keyValues.join(",");

    if (selected) {
      // payload-
      const payload = {
        itemid: paramObject.id,
        attributeid: Attributeid || "",
        attributevalueid: commaSeparatedValues,
        loginUserId,
      };

      // post-
      axios
        .post(`${config.itemsBaseUrl}/items/itemattributeinsert`, payload, {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        })
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            autoGenerationFunction(res.data.ResponseCode);
            let filtervalue = data?.newAttributeValue.filter(
              (e) => e.Attributeid != Attributeid
            );
            setData({
              ...data,
              newAttributeValue: filtervalue,
            });
            setData({
              ...data,
              newAttributeValue: [...filtervalue, ...res.data.ResponseData],
            });
          } else if (
            res.data.ResponseCode === "ERROR" &&
            res.data.ResponseID === -1
          ) {
            toastError(ERROR_EXISTS);
          } else {
            toastError(ERROR_MESSAGE);
          }
        })
        .catch((err) => console.log(err));
    }
  };

  // Handle Attribute Change-
  const handleChangeAttributeValue = (selected, Attributeid, index, ID) => {
    insertAttributeFunction(selected, Attributeid);

    if (selected.length === 0) {
      deleteTableRows(index);
    }
  };

  // Pull Attribute-
  const handlePullAttribute = (index, Attributeid, ID) => {
    setPull(!pull);
    const allAttribute = data?.newGlobalAttribute
      ?.filter((d) => d.Attributeid === Attributeid)
      ?.map((el) => {
        return {
          label: el.Name,
          value: el.ID,
          attributeId: el.Attributeid,
        };
      });
    insertAttributeFunction(allAttribute, Attributeid);
  };

  // Show Selected Attribute function-
  const showSelectedAttributeFunction = (Attributeid) => {
    return data?.newAttributeValue
      ?.filter((d) => d.Attributeid === Attributeid)
      ?.map((el) => {
        return {
          label: el.Name,
          value: el.Attributevalueid,
          attributeId: el.Attributeid,
        };
      });
  };

  // Show Selected All Options  function-
  const showAllSelectedOptionsFunction = (Attributeid, ID) => {
    return data?.newGlobalAttribute
      ?.filter((d) => d.Attributeid === Attributeid)
      ?.map((el) => {
        return {
          label: el.Name,
          value: el.ID,
          attributeId: el.Attributeid,
        };
      })
      ?.filter(
        (option) =>
          !data?.newAttributeValue
            ?.filter((d) => d.Attributeid === ID)
            ?.map((el) => {
              return {
                label: el.Name,
                value: el.ID,
                attributeId: el.Attributeid,
              };
            })
            .some((item) => item.label == option.label)
      );
  };

  // Disable pull button on the basis of attribute id-
  const disablePullButtonFunction = (Attributeid) => {
    return (
      data?.newAttributeValue?.filter((d) => d.Attributeid === Attributeid)
        .length ===
      data?.newGlobalAttribute?.filter((d) => d.Attributeid === Attributeid)
        .length
    );
  };

  return (
    <>
      {data?.newAttributeName?.map((el, index) => (
        <>
          <Loader loading={loading} />
          <tr key={index}>
            <td>{el.Name}</td>
            <td>
              <Select
                ref={selectRef}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isMulti={true}
                isClearable={true}
                placeholder=""
                // styles={selectStyles}
                onChange={(value) =>
                  handleChangeAttributeValue(
                    value,
                    el.Attributeid,
                    index,
                    el.ID
                  )
                }
                id="Attributes"
                name="Attributes"
                value={showSelectedAttributeFunction(el.Attributeid)}
                options={showAllSelectedOptionsFunction(el.Attributeid, el.ID)}
              />
            </td>
            <td>
              <i
                className="fa fa-trash text-red fa-2x"
                data-bs-toggle="tooltip"
                title="Delete"
                onClick={() => deleteTableRows(index)}
              />
            </td>
            <td>
              <input
                type="button"
                className={"btn btn-primary"}
                onClick={() =>
                  handlePullAttribute(index, el.Attributeid, el.ID)
                }
                value={"Pull"}
                disabled={disablePullButtonFunction(el.Attributeid)}
              />
            </td>
          </tr>
        </>
      ))}
    </>
  );
};

const selectStyles = {
  control: (provided) => ({
    ...provided,
    width: "100%",
    height: "auto",
    position: "relative",
  }), // dropdown input css
  menu: () => ({
    boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
    position: "absolute",
    background: "#f8f8f8",
    width: "100%",
    zIndex: 99,
    // border: "solid orange",
  }),
  valueContainer: () => ({
    // padding: "0px 6px !importan",
    height: "auto !important",
    display: "contents",
  }),
};

export default ItemAttributeTableRows;
